<template>
  <div>
    <v-card
      class="ma-1 border--goldens"
      :class="classes"
      rounded
      ripple
      v-bind="$attrs"
      v-on="$listeners"
    >
      <div v-if="icon">
        <v-btn class="check-btn" fab dark x-small color="primary">
          <v-icon class="f10" dark>{{ icon }}</v-icon>
        </v-btn>
      </div>
      <v-img
        cover
        :aspect-ratio="aspectRatio"
        v-bind="$attrs"
        v-on="$listeners"
        alt="imgcard"
      ></v-img>
      <slot></slot>
    </v-card>
    <div v-if="walletId" class="text-left f10 ml-1 my-1">
      ID:
      <span class="text-uppercase">{{ walletId }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageCard',
  props: {
    classes: { type: String, default: '', required: false },
    aspectRatio: { type: String, default: '' },
    icon: { type: String, default: '' },
    walletId: { type: String, default: '' }
  }
}
</script>

<style lang="scss">
.check-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 18px !important;
  height: 18px !important;
  z-index: 1;
}
</style>
